import { render, staticRenderFns } from "./SurveyResponsesStatistics.vue?vue&type=template&id=c44b7bc4"
import script from "./SurveyResponsesStatistics.vue?vue&type=script&lang=js"
export * from "./SurveyResponsesStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports